<template>
  <div class="wrapper">
    <div v-if="!!this.errors?.line_error" class="error">
      <p class="title">Разные типы в одной линии:</p>
      <p class="value" v-for="item in this.errors.line_error">
        {{item}}
      </p>
    </div>
    <div v-if="!!this.errors?.empty_second_param_type" class="error">
      <p class="title">Пустой второй конструктив:</p>
      <p class="value" v-for="item in this.errors.empty_second_param_type">
        {{item}}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "floor-map-error",
  props: ['data'],
  computed: {
    errors() {
      if(!this.data?.data) return
      const {line_error, empty_second_param_type} = this.data.data
      return {
        line_error: line_error?.split('/n') || null,
        empty_second_param_type: empty_second_param_type?.split('/n') || null,
      }
    }
  }
}
</script>

<style scoped lang="scss">
.wrapper {
  margin-top: 15px;
}
.error {
  max-width: 570px;
  min-width: 250px;
  margin-bottom: 20px;
  padding: 10px 12px;
  border: 1px solid var(--ms-danger-bg);
  border-radius: var(--ms-radius-sm);

  &:last-of-type {
    margin-bottom: 0
  }

  @media (max-width: 576px) {
    max-width: 100%;
  }
}
.title {
  font-weight: 700;
  color: var(--ms-danger);
  margin: 0 0 5px 0;
}
.value {
  margin: 0;
  background-color: var(--ms-danger-bg);
  color: var(--ms-text);
  padding: 3px 10px;
  margin-top: 8px;
  border-radius: var(--ms-radius-sm);
}
</style>
